import apiClient from "./apiClient";
import { getStationUsers } from "./stationUserService";

const toUserList = (payload) => {
  const directList =
    payload?.users ??
    payload?.stationUsers ??
    payload?.station_users ??
    payload?.data?.users ??
    payload?.data?.stationUsers ??
    payload?.data?.station_users ??
    payload?.data;

  if (Array.isArray(directList)) {
    return directList;
  }

  const singleUser = payload?.user ?? payload?.data?.user;

  if (singleUser && typeof singleUser === "object") {
    return [singleUser];
  }

  if (directList && typeof directList === "object") {
    return [directList];
  }

  const nestedArray = Object.values(payload || {}).find((value) =>
    Array.isArray(value)
  );

  if (Array.isArray(nestedArray)) {
    return nestedArray;
  }

  return [];
};

export const getAllUsers = async (params = {}) => {
  const response = await apiClient.get("/api/users/dropdown", { params });
  return toUserList(response.data);
};

export const getUsers = async (params = {}) => {
  const response = await apiClient.get("/api/users", { params });
  return toUserList(response.data);
};

export const getScopedUsers = async (params = {}) => {
  try {
    const dropdownUsers = await getAllUsers(params);

    if (Array.isArray(dropdownUsers) && dropdownUsers.length > 0) {
      return dropdownUsers;
    }
  } catch (_error) {
    // Fall through to additional endpoints below.
  }

  try {
    const users = await getUsers(params);

    if (Array.isArray(users) && users.length > 0) {
      return users;
    }
  } catch (_error) {
    // Fall through to legacy endpoint below.
  }

  try {
    const stationUsers = await getStationUsers(params);

    if (Array.isArray(stationUsers) && stationUsers.length > 0) {
      return stationUsers;
    }
  } catch (_error) {
    // Ignore and return empty list below.
  }

  return [];
};
